<template>
  <div>
    <div class="headerTopWrap">
      <div class="headerTop">
        <div>
          <a class="headA" :href="config.headerTop.href" target="_blank">{{config.headerTop.name}}</a>
        </div>
        <div class="headerRightTop">
          <div v-if="gzteacher" style="margin-right: 40px;">
            <a class="headA" href="https://www.gzteacher.com/" target="_blank">登录个人空间</a>
          </div>
          <div v-if="appUtils.getAppId() != 'APPT047'" class="headA dloadApp" @mouseover="showYjsCode=true" @mouseout="showYjsCode=false">
            <svg t="1605168715321" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4821" width="20" height="20"><path d="M351.988168 131.844817c-22.174022 0-45.686529 23.411199-45.686529 45.686529l0 639.606283c0 22.37459 24.00267 45.686529 45.686529 45.686529l319.803653 0c20.455891 0 45.685505-23.433712 45.685505-45.686529L717.477326 177.530322c0-22.397103-23.556509-45.686529-45.685505-45.686529M466.203466 177.530322l114.216321 0c12.625552 0 22.596647 5.097088 22.596647 11.432377 0 6.312776-11.912307 11.409864-22.596647 11.409864L443.360202 200.372563c-11.45489 0-22.508643-5.097088-22.508643-11.409864 0-6.335289 11.165294-11.432377 22.508643-11.432377L466.203466 177.530322zM512.06805 817.260425c-12.224416 0-23.155373-10.151197-23.155373-22.954805 0-12.805654 10.930957-23.010063 23.155373-23.010063 12.893658 0 22.833031 10.205433 22.833031 23.010063C534.901081 807.109228 524.961708 817.260425 512.06805 817.260425L512.06805 817.260425zM671.791821 725.764572l-319.803653 0L351.988168 246.059092l319.803653 0L671.791821 725.764572z" p-id="4822" fill="#707070"></path></svg>
            APP下载
            <div class="codeBox" v-if="showYjsCode">
              <img src="../../../static/images/yijiaoshi_code.png" alt="">
            </div>
          </div>
          <div class="headA">
            <img src="../../../static/images/telephone1.png" alt="" width="14" height="14">
            &nbsp;
            服务热线：{{config.headerTop.hotTel}}
          </div>
        </div>
      </div>
    </div>
    <div class="header">


      <div class="header-contain">
        <el-image class="logoImg" :src="config.headerLogo.src"></el-image>
        <div class="header-nav">
          <p @click="navClick(0)" :class="NavActive==='home'?'active':''">首页</p>
          <p @click="navClick(1)" :class="NavActive==='trainStatistics'?'active':''">培训统计</p>
           <!--<p @click="navClick(2)" :class="NavActive==='square'?'active':''">学校广场</p>-->
          <p @click="navClick(3)" :class="NavActive==='resourceCenter'?'active':''">资源中心</p>
          <p @click="navClick(5)" :class="NavActive==='community'?'active':''">学校社区</p>
          <p @click="navClick(4)" :class="NavActive==='consultCourse'?'active':''" v-if="isSouthTeacher">课程列表</p>
          <!-- <div>
            <p v-if="!userName" @click="loginClick()" class="login-btn">登录</p>
            <label v-if="userName" class="userName">{{userName}}</label>
            <label v-if="userName" class="userName" style="cursor: pointer" @click="gotoUserCenter()">进入个人中心</label>
            <label v-if="userName" class="logout" @click="logoutClick()">退出</label>
          </div> -->
        </div>
      </div>
    </div>
    <div class="conain">
      <router-view></router-view>
    </div>
    <div class="footer" v-html="config.footerInfo">
     <!-- <p>
        <span>主办方：{{config.footerInfo.zhuban}} </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <span>指导单位：{{config.footerInfo.zhidao}}</span>
      </p>
      <p>
        <span>承办方：{{config.footerInfo.chenban}}</span>&nbsp;&nbsp;&nbsp;&nbsp;
        <span>{{config.footerInfo.timeRight}}</span>&nbsp;&nbsp;&nbsp;&nbsp;
        <span>{{config.footerInfo.bianhao}}</span>
      </p>
      <p>
        <span>客户服务邮箱：{{config.footerInfo.email}} &nbsp;&nbsp; | &nbsp;&nbsp; 教育服务热线：{{config.footerInfo.tel}}</span>
      </p>-->
    </div>
    <!-- <div class="kefu1" :style="{ zIndex: 9999, top: 460+'px',  width: width+'px', height: height+'px' }">
      <div class="kefu1_mdl yahei clearfix" @mouseleave ="mouseleave">
        <span class="kefu1_btn" @mouseenter="mouseenter"><i></i>在线客服</span>
        <div class="kefu1_main">
          <h3 class="kefu1_title">在线客服</h3>
          <div class="kefu1_ctn" style="height:90px"> <a class="ee"  onclick="doyoo.util.openChat('g=10054581');return false;"  target="_blank"></a> <span class="tel"></span> </div>
          <div class="kefu1_foot"><i></i>现代教育服务品牌</div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
  import config from '../../core/config';
  import {CheckToken} from '../../core/checkToken';

  export default {
    name: '',
    data () {
      return {
        config,
        navIndex: 0,
        userName:'',
        NavActive:'',
        width: 41,
        height: 170,
        // right: -168,
        isopen: false,
        isSouthTeacher: false,
        showYjsCode: false,
        gzteacher: false
      };
    },
    watch: {
      $route(index) {
        let path = index.path.substr(1);
        this.handleSelect(path);
      }
    },
    created () {
      let projectId = JSON.parse(localStorage.getItem('TSGC_PROJECTID')).localStorageitem;
      if (this.appUtils.getAppId() == 'APPYS02' && projectId == '0c79f8c2652d4f8db3f0c1cf1339a40c'){
        this.isSouthTeacher = true;
      }
      
    },
    beforeMount() {
      this.getActiveNav();
    },
    mounted(){
      this.userName = this.appUtils.getUserName();
      CheckToken.start(0);
      CheckToken.start(30*60*1000);

      if (window.location.host == 'gzts.gzteacher.com' || window.location.host == 'http://shxy.ts.test.gdteacher.com/' || window.location.host == 'localhost:8090'){
        this.gzteacher = true;
      }
      //客服

      // $(".kefu1_btn").hover(function(){
      //   $(".kefu1").width(208).height(413)
      //   $(".kefu1_mdl").stop().animate({right:"0px"},300);
      // })

      // $(".kefu1_mdl").mouseleave(function(){
      //   $(".kefu1_mdl").stop().animate({right:"-168px"},300,function(){
      //     $(".kefu1").width(41).height(170);
      //   });
      // })
    },
    methods: {
      mouseenter: function (){
        // $(".kefu1").width(208).height(413)
        this.$nextTick(function () {
          this.width = 208;
          this.height = 413;
          // this.right = 0;
          this.isopen = true;
        });
      },
      mouseleave : function (){
        this.$nextTick(function () {
          if (this.isopen){
            this.width = 41;
            this.height = 170;
            // this.right = -168;
            this.isopen = false;
          }
        });
      },
      // 设置导航高亮
      getActiveNav: function() {
        let currentUrl = window.location.href;
        let path = currentUrl.lastIndexOf('\/');
        this.NavActive = currentUrl.substring(path + 1,currentUrl.length);
      },
      handleSelect(path) {
        this.NavActive = path;
      },
      loginClick(){
        console.log('登录');
        this.$router.push({
          path:'/login'
        });
      },
      logoutClick(){
        window.localStorage.removeItem(this.constStatic.USER_INFO);
        this.userName = this.appUtils.getUserName();
      },
      gotoUserCenter(){
        window.open(this.apis.studySpace + '?jti=' + this.appUtils.getJti()+'&projectId='+this.appUtils.getProjectId());
      },
      navClick(index){
        this.navIndex = index;
        switch (index) {
          case 0: {
            this.$router.push({ path: '/' });
            break;
          }
          case 1: {
            this.$router.push({ path: '/trainStatistics' });
            break;
          }
          case 2: {
            // console.log('广场');
             this.$router.push({ path: '/square' });
            break;
          }
          case 3: {
            this.$router.push({ path: '/resourceCenter' });
            // console.log('中心');
            break;
          }
          case 4: {
            this.$router.push({ path: '/consultCourse' });
            break;
          }
          case 5: {
            this.$router.push({ path: '/community' });
            break;
          }
          default:
            break;
        }
      }
    }
  };
</script>
<style lang="scss" scoped>
  @import '../../common/common.scss';
  .headerTopWrap {
    display: flex;
    justify-content: center;
    background-color: #F5F5F5;
    line-height: 28px;
    .headerTop {
      width: 1150px;
      display: flex;
      justify-content: space-between;
      .headerRightTop{
        display: flex;
        .dloadApp{
          display: flex;
          align-items: center;
          margin-right: 40px;
          padding-right: 6px;
          position: relative;
          cursor: pointer;
          &:hover{
            background: #fff;
          }
          .codeBox{
            z-index: 1000;
            position: absolute;
            width: 160px;
            height: 160px;
            top: 34px;
            left: -42px;
            img{
              width: 100%;
              height: 100%;
            }
          }
        }
      }
      .headA {
        color: #595757;
        font-size: 12px;
      }
    }
  }
  .header {
    display: flex;
    justify-content: center;
    height: 70px;
    background-color: white;
    border-bottom: 1px solid #eee;
    .header-contain {
      height: 100%;
      width: 1160px;
      min-width: 1160px;
      max-width: 1160px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .logoImg{
        /*width: 445px;*/
        /*height: 21px;*/
      }
      .header-nav {
        display: flex;
        align-items: center;
        .active {
          color: $green;
        }
        p {
          line-height: 70px;
          padding: 0 10px;
          color: $color-6;
          font-size: $largeFont;
          &:hover, :focus {
            color: $green;
            cursor: pointer;
          }
        }
        .login-btn {
          background-color: $sGreen;
          margin-left: 10px;
          line-height: 45px;
          color: white;
          padding: 0 25px;
          &:hover, :focus {
            background-color: $green;
            color: white;
          }
        }
        .logout{
          font-size: $largeFont;
          color: $color-6;
          cursor: pointer;
          &:hover, :focus {
            color: $green;
          }
        }
        .userName{
          font-size: $largeFont;
          color: $color-6;
          &:hover,:focus{
            color: $green;
          }
        }
      }
    }
  }

  .conain {
    background-color: white;
    min-height: calc(100vh - 211px);
  }

  .footer {
    background-color: $green;
    text-align: center;
    font-weight: 400;
    color: white;
    line-height: 26px;
    padding: 31px 0;
    font-size: $middleFont;
  }



  /* 客服 */
.kefu1{position:fixed; right:0px; top:200px; z-index:9; _position:absolute; _top:expression(eval(document.documentElement.scrollTop)+200); width:41px; height:170px; overflow:hidden;}
.kefu1_mdl{position:absolute; top:0px; width:208px;}
.kefu1_btn{display:inline-block; float:left; width:23px; text-align:center; padding:15px 9px;background:#cc0001; color:#fff; font-size:16px; line-height:18px; border-top-left-radius:5px; border-bottom-left-radius:5px;}
.kefu1_btn i{display:inline-block; width:23px; height:23px; background:url(http://css.gzedu.com/teacher_oucnet_cn/person_center/v1.0/style/images/kefu_ico.png?rt) no-repeat -180px -116px; margin-bottom:5px;}
.kefu1_main{ _float:left; overflow:hidden; background:#cc0001; border:1px solid #ae0a0b; padding:3px;}
.kefu1_title{ height:30px; line-height:30px; color:#fff; font-size:18px; text-align:center;}
.kefu1_ctn{background:#fff; text-align:center; padding:10px 0;}
.kefu1_ctn .qq{display:inline-block; width:150px; height:46px; background:url(http://css.gzedu.com/teacher_oucnet_cn/person_center/v1.0/style/images/kefu_ico.png?1_) no-repeat 0px 0px; margin-bottom:5px;}
.kefu1_ctn .ee{display:inline-block; width:150px; height:47px; background:url(http://css.gzedu.com/teacher_oucnet_cn/person_center/v1.0/style/images/kefu_ico.png?r2) no-repeat 0px -52px; margin-bottom:5px;}
.kefu1_ctn .qq:hover{background-position:right 0px;}
.kefu1_ctn .ee:hover{background-position:right -52px;}
.kefu1_ctn .tel{display:inline-block; width:150px; height:41px; background:url(http://css.gzedu.com/teacher_oucnet_cn/person_center/v1.0/style/images/kefu_ico.png?rt2) no-repeat 0px -110px;}
.kefu1_ctn .tel2{display:inline-block; width:150px; height:41px; background:url(http://css.gzedu.com/teacher_oucnet_cn/person_center/v1.0/style/images/kefu_ico.png?rt2) no-repeat 0px -155px;}
.kefu1_foot{color:#fff; line-height:16px; padding:3px 0; text-align:center;}
.kefu1_foot i{display:inline-block; width:42px; height:20px;  background:url(http://css.gzedu.com/teacher_oucnet_cn/person_center/v1.0/style/images/kefu_ico.png?rt2) no-repeat -228px -116px; float:left; margin-top:-2px;}
</style>



// WEBPACK FOOTER //
// src/pages/wrap/index.vue